import { post } from '../utils/ApiUtil';
import type {
  PayCashierSessionView,
  QueryPayCashierStatusResult,
  SubmitPayCashierPayResult,
  PayClientType,
  PayMethodCode,
} from './CashierType';

export const PayCashierApi = {
  getSession(sessionToken: string): Promise<PayCashierSessionView | string> {
    return post<{ sessionToken: string }, PayCashierSessionView>(
      '/pay/cashier/getSession',
      { sessionToken },
      { quiet: true },
    );
  },

  submitPay(
    sessionToken: string,
    payMethod: PayMethodCode,
    clientType: PayClientType,
  ): Promise<SubmitPayCashierPayResult | string> {
    return post<
      { sessionToken: string; payMethod: string; clientType: string },
      SubmitPayCashierPayResult
    >(
      '/pay/cashier/submitPay',
      { sessionToken, payMethod, clientType },
      { quiet: true },
    );
  },

  queryPayStatus(sessionToken: string): Promise<QueryPayCashierStatusResult | string> {
    return post<{ sessionToken: string }, QueryPayCashierStatusResult>(
      '/pay/cashier/queryPayStatus',
      { sessionToken },
      { quiet: true },
    );
  },
};
